export enum MIXPANEL_STATISTICS_PROPS {
    AVERAGE_QUALITY = 'Average Quality',
    AVERAGE_VARIATIONS_QUALITY = 'Average Variations Quality',
    AVERAGE_RPI = 'Average RPI',
    MINIMAL_RPI = 'Minimal RPI',
    MAXIMAL_RPI = 'Maximal RPI',
    LOGOS_COUNT = 'Logos Count',
    LOGOS_COUNT_PER_PAGE = 'Logos Count Per Page',
    LOGOS_PERCENTAGE = 'Logos Percentage',
    LOGOS_COUNT_WITH_EXTRA = 'Logos Count With Extra',
    STYLE_MATCHING = 'Style Matching',
    SINGLE_STYLE_MATCHING = 'Single Style Matching',
}

export enum MIXPANEL_STATISTICS_PREFIXES {
    ACTUAL = 'Actual',
    EXPECTED = 'Expected',
}
